import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    agreement: 'Accept the terms and conditions',
    compliance: 'Add your information',
    description: {
      plural:
        'There are just **{totalSteps}** steps to complete before accessing your new IBAN. This will just take a few moments.',
      singular:
        'There are just **{totalSteps}** step to complete before accessing your new IBAN. This will just take a few moments.',
    },
    registrationDate: 'Enter your date of registration',
    title: 'What you still need to do',
  },
  fr: {
    agreement: 'Accepter les CGU',
    compliance: 'Compléter les formalités',
    description: {
      plural:
        'Vous n’avez que **{totalSteps}** étapes à compléter avant d’accéder à votre nouvel IBAN. Cela ne vous prendra que quelques instants.',
      singular:
        'Vous n’avez que **{totalSteps}** étape à compléter avant d’accéder à votre nouvel IBAN. Cela ne vous prendra que quelques instants.',
    },
    registrationDate: 'Remplir votre date d’immatriculation',
    title: 'Ce qu’il vous reste à faire',
  },
});

export default locales;
